export default __webpack_public_path__ + "static/callahan-quote-banner-2e3e205c3e20ef625301eff942c8394b.jpg";